import { Injectable } from '@angular/core';
import { first, Observable, ReplaySubject, Subject } from 'rxjs';

import { ExportableData } from '../models/exportable-data';

@Injectable()
export class FilteredDataService {
    public readonly filteredData$: Observable<Record<string, ExportableData>>;
    public readonly fullData$: Observable<Record<string, ExportableData>>;
    private readonly filteredData: Subject<Record<string, ExportableData>> = new ReplaySubject(1);
    private readonly fullData: Subject<Record<string, ExportableData>> = new ReplaySubject(1);

    constructor() {
        this.filteredData$ = this.filteredData.asObservable();
        this.fullData$ = this.fullData.asObservable();
        this.filteredData.next({});
        this.fullData.next({});
    }

    updateFilteredData(newData: Record<string, ExportableData>): void {
        this.filteredData
            .pipe(first())
            .subscribe({
                next: (existingData) => this.filteredData.next({ ...existingData, ...newData }),
            });
    }

    updateFullData(newData: Record<string, ExportableData>): void {
        this.fullData
            .pipe(first())
            .subscribe({
                next: (existingData) => this.fullData.next({ ...existingData, ...newData }),
            });
    }

    clearFilteredData(newData: Record<string, ExportableData> = {}): void {
        this.filteredData.next({ ...newData });
    }

    clearFullData(newData: Record<string, ExportableData> = {}): void {
        this.fullData.next({ ...newData });
    }
}
